export const revenueForecastSelectedFilterListStateKey = 'revenue-forecast-selected-filter-list';
export const revenueForecastViewOptionsStateKey = 'revenue-forecast-view-options';
